import { Pipe, PipeTransform } from '@angular/core';

declare function addLeadingZero(value: number): number;

@Pipe({
  name: 'longReadableDate'
})
export class LongReadableDatePipe implements PipeTransform {

  transform(dateString: string): string {
    const date = new Date(dateString);
    return addLeadingZero(date.getDate()) + '.' + addLeadingZero((date.getMonth() + 1)) + '.' + addLeadingZero(date.getFullYear()) + ' ' + addLeadingZero(date.getHours()) + ':' + addLeadingZero(date.getMinutes()) + ':' + addLeadingZero(date.getSeconds());
  }

}
